import { RESIZE, SCROLL } from './constants';

export const resize = () => ({
  payload: global.window,
  type: RESIZE,
});

export const scroll = () => ({
  payload: global.window,
  type: SCROLL,
});
